export default {
  masterChef: {
    11155420: '0xB4A466911556e39210a6bB2FaECBB59E4eB7E43d',
    10: '0xa5f8C5Dbd5F286960b9d90548680aE5ebFf07652',
  },
  masterChefV1: {
    11155420: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    10: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
  },
  sousChef: {
    11155420: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    10: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lotteryV2: {
    11155420: '0x5790c3534F30437641541a0FA04C992799602998',
    10: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
  },
  // TODO: multi
  multiCall: {
    11155420: '0xcA11bde05977b3631167028862bE2a173976CA11',
    10: '0xcA11bde05977b3631167028862bE2a173976CA11',
  },
  pancakeProfile: {
    10: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    11155420: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeBunnies: {
    10: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    11155420: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    10: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    11155420: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    10: '0xE7e53A7e9E3Cf6b840f167eF69519175c411155420e149',
    11155420: '',
  },
  pointCenterIfo: {
    10: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    11155420: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2911155420e3',
  },
  bunnySpecial: {
    10: '0xFee8A195570a18461146F401d6033f5ab3380849',
    11155420: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetitionEaster: {
    10: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    11155420: '0xC787F45B833721ED3aC46E99b703B3E1E01abb11155420',
  },
  tradingCompetitionFanToken: {
    10: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    11155420: '',
  },
  tradingCompetitionMobox: {
    10: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    11155420: '',
  },
  tradingCompetitionMoD: {
    10: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    11155420: '',
  },
  easterNft: {
    10: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    11155420: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    10: '0x45c54210128a065de780C4B0Df3d16664f7f859e',
    11155420: '0x683433ba14e8F26774D43D3E90DA6Dd7a22044Fe',
  },
  cakeFlexibleSideVault: {
    10: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
    11155420: '',
  },
  predictionsBNB: {
    10: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    11155420: '',
  },
  predictionsEJOE: {
    10: '0x0E3A8078EDD2021dadcdE733C6b4a86E51EE8f07',
    11155420: '',
  },
  chainlinkOracleBNB: {
    10: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    11155420: '',
  },
  chainlinkOracleEJOE: {
    10: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    11155420: '',
  },
  predictionsV1: {
    10: '0x516ffd7d1e0ca40b1879935b2de87cb20fc1124b',
    11155420: '',
  },
  bunnySpecialCakeVault: {
    10: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    11155420: '',
  },
  bunnySpecialPrediction: {
    10: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    11155420: '',
  },
  bunnySpecialLottery: {
    10: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    11155420: '0x382cB411155420110F398F0f152cae82821476AE51c9cF',
  },
  bunnySpecialXmas: {
    10: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    11155420: '',
  },
  farmAuction: {
    10: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    11155420: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  AnniversaryAchievement: {
    10: '0x787980da5491118C3cB33B21aB50c8c379D2C552',
    11155420: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
  },
  nftMarket: {
    10: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    11155420: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    10: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    11155420: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    10: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    11155420: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
  potteryDraw: {
    10: '0x01871991587d5671f3A2d4E2BcDC22F4E026396e',
    11155420: '0xDB9D365b50E62fce747A90515D2bd1254A16EbB9',
  },
  // TODO: multi
  zap: {
    10: '0xD4c4a7C55c9f7B3c48bafb6E8643Ba79F42418dF',
    11155420: '0xD85835207054F25620109bdc745EC1D1f84F04e1',
  },
  iCake: {
    10: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
    11155420: '',
  },
}
